import React, { memo, useCallback } from "react";
import UnifiedSearch from "./UnifiedSearch";
import SearchErrorBoundary from "./SearchErrorBoundary";
import "./SearchBar.css";

/**
 * Wraps the homepage search bar in an error boundary so a search failure
 * doesn't take down the whole home page. The bar itself is manual location
 * search only -- the AI experience is entered from the floating
 * "Talk to Me" pill instead (components/TalkToMeWidget.jsx).
 */
function SearchBarContainer({ onSearch }) {
    const handleSearch = useCallback((q, opts) => onSearch?.(q, opts), [onSearch]);
    return (
        <div className="search-wrap">
            <div className="dual-search-bar">
                <SearchErrorBoundary>
                    <UnifiedSearch onSearch={handleSearch} />
                </SearchErrorBoundary>
            </div>
        </div>
    );
}

export default memo(SearchBarContainer);
